import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppointmentForm as RSMuiAppointmentForm } from '@devexpress/dx-react-scheduler-material-ui'

import AppBar from '@mui/material/AppBar'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import { TransitionProps } from '@mui/material/transitions'

import CloseIcon from '@mui/icons-material/Close'

import CreateConsultationPage from '@/pages/create-consultation/CreateConsultationPage'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" mountOnEnter unmountOnExit ref={ref} {...props} />
})

function CustomCommandLayout(props: RSMuiAppointmentForm.CommandLayoutProps) {
  const { onCancelButtonClick } = props
  const { t } = useTranslation()

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          <Tooltip title={<span>{t('tooltip.button.close')}</span>}>
            <IconButton color="inherit" onClick={onCancelButtonClick}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  )
}

function CustomLayout(props: RSMuiAppointmentForm.LayoutProps) {
  return (
    <RSMuiAppointmentForm.Layout
      {...props}
      style={{
        width: '100%'
      }}
    >
    </RSMuiAppointmentForm.Layout>
  )
}

function CustomOverlay(props: RSMuiAppointmentForm.OverlayProps) {
  const { children, onHide, visible = false } = props

  return (
    <Dialog open={visible} onClose={onHide} fullScreen TransitionComponent={Transition}>
      {children}
    </Dialog>
  )
}

export function AppointmentForm() {
  const [visible, setVisible] = useState<boolean>(false)

  const handleVisibilityChange = useCallback(() => {
    setVisible(prevValue => !prevValue)
  }, [])

  const CustomBasicLayout = useCallback((props: RSMuiAppointmentForm.BasicLayoutProps) => {
    const { appointmentData } = props
    const { startDate } = appointmentData

    return (
      <CreateConsultationPage onComplete={handleVisibilityChange} startDate={startDate ? new Date(startDate).toISOString() : undefined} />
    )
  }, [handleVisibilityChange])


  return (
    <RSMuiAppointmentForm
      visible={visible}
      onVisibilityChange={handleVisibilityChange}
      commandLayoutComponent={CustomCommandLayout}
      layoutComponent={CustomLayout}
      overlayComponent={CustomOverlay}
      basicLayoutComponent={CustomBasicLayout}
    />
  )
}

export default AppointmentForm